import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { TextButton, Text } from 'wix-style-react';
import s from './Enterprise.scss';
import { EnterpriseFeaturesItemData } from './EnterpriseFeatures';
import classNames from 'classnames';

export const EnterpriseFeaturesItem: React.FC<EnterpriseFeaturesItemData> = ({
  icon,
  title,
  body,
  link,
}) => {
  const { t } = useTranslation();
  return (
    <div key={title} className={s.enterpriseFeature}>
      <div className={classNames(s.featureIcon, s[icon])}></div>
      <Text weight='bold' className={s.featureTitle}>
        {t(title)}
      </Text>
      <Text>
        <Trans i18nKey={body} values={link}>
          feature text
          <TextButton as='a' size='medium' target='_blank' href={t(link ?? '')}>
            link label
          </TextButton>
        </Trans>
      </Text>
    </div>
  );
};
